import { combineReducers } from '@reduxjs/toolkit';
import { enableMapSet } from 'immer';
import agave, { AgaveState } from './agaveSlice';
import groups, { GroupsState } from 'app/pages/store/groupsSlice';
import funding, { FundingState } from './fundingSlice';
import procore, { ProcoreState } from './procoreSlice';
import cardData, { CardDataState } from './CardDataSlice/cardDataSlice';
import spendRules, { SpendRulesState } from './spendRulesSlice';
import spendWidget, { SpendWidgetState } from './spendWidgetSlice';
import budgetWidget, { BudgetWidgetState } from './budgetWidgetSlice';
import reimbursements, { ReimbursementsState } from './reimbursementsSlice';
import transactions, { TransactionsState } from './transactionsSlice';
import projectGroups, { ProjectGroupState } from './projectGroupSlice';
import priorityActions, { priorityActionsState } from './priorityActionsSlice';
import topMerchantsWidget, { TopMerchantsWidgetState } from './topMerchantsWidgetSlice';
import downloadTransactions, { DownloadTransactionsState } from './downloadTransactionsSlice';
import onboard from './reviewOnboardSlice';
import users from 'app/pages/store/usersSlice';
import transactionFilterOptions, { TransactionFilterOptionsState } from './transactionFilterOptionsSlice';
import type { ReviewOnboardState } from './reviewOnboardSlice';
import type { TeamUsersState } from 'app/pages/store/usersSlice';

enableMapSet();

export interface CardsState {
  agave: AgaveState;
  budgetWidget: BudgetWidgetState;
  cardData: CardDataState;
  downloadTransactions: DownloadTransactionsState;
  funding: FundingState;
  groups: GroupsState;
  projectGroups: ProjectGroupState;
  onboard: ReviewOnboardState;
  priorityActions: priorityActionsState;
  procore: ProcoreState;
  reimbursements: ReimbursementsState;
  spendRules: SpendRulesState;
  spendWidget: SpendWidgetState;
  topMerchantsWidget: TopMerchantsWidgetState;
  transactions: TransactionsState;
  transactionFilterOptions: TransactionFilterOptionsState;
  users: TeamUsersState;
}

const reducer = combineReducers({
  agave,
  budgetWidget,
  cardData,
  downloadTransactions,
  funding,
  groups,
  onboard,
  projectGroups,
  priorityActions,
  procore,
  reimbursements,
  spendRules,
  spendWidget,
  topMerchantsWidget,
  transactions,
  transactionFilterOptions,
  users,
});

export default reducer;
